<template>
    <div>
        <div id="title">{{ content }}</div>
        <div id="sosMap"></div>
    </div>
</template>

<script>    
import { EventBus } from '../../utils/eventbus.js';
export default {
    data() {
        return {
            content: ''
        }
    },
    created() {
        EventBus.$on('sos-warn', this.handleSosEvent);
    },
    beforeDestroy() {
        EventBus.$off('sos-warn', this.handleSosEvent);
    },   
    methods: {
        setMap(longitude, latitude){
            var map = new BMapGL.Map("sosMap");
            var point = new BMapGL.Point(longitude, latitude);
            map.centerAndZoom(point, 14);

            let marker = new BMapGL.Marker(point); 
            map.addOverlay(marker);
            let content = 'sos';
            var label = new BMapGL.Label(content, {  
                position: point,                         
                offset: new BMapGL.Size(10, 6)
            });
            map.addOverlay(label);

            var zoomCtrl = new BMapGL.ZoomControl();
            map.addControl(zoomCtrl);
            var scaleCtrl = new BMapGL.ScaleControl();
            map.addControl(scaleCtrl);            
        },
        handleSosEvent(data) {
            let num_arr = data.location.split(',');
            let lat = parseFloat(num_arr[0]);
            let lon = parseFloat(num_arr[1]);
            this.setMap(lon,lat);
            let desc = data.id;
            this.content = 'SOS: '+desc.substring(0,15)+' '+desc.substring(15,34);
        }
    },
    mounted: function() {
        let pos_str = this.$route.params.position;
        let desc = this.$route.params.desc;
        this.content = 'SOS: '+desc.substring(0,15)+' '+desc.substring(15,34);
        let num_arr = pos_str.split(',');
        let lat = parseFloat(num_arr[0]);
        let lon = parseFloat(num_arr[1]);
        this.setMap(lon,lat);
    }
}
</script>

<style scoped>
#title {
    font-size: 15px;
    color: red;
    font-weight: bold;
}

#sosMap{
    margin-top: 10px;
    width: 100%;
    height: 660px;
}
</style>
    